import LegalShell from "@/pages/LegalShell";

export default function Privacy() {
  return (
    <LegalShell title="Privacy Policy" effective="1 February 2026">
      <p>
        This Privacy Policy explains how <strong>RIF Master</strong>, operated by <strong>Dr. Mona Shroff, MD</strong>,
        collects, uses and protects information when you use the Service.
      </p>

      <h2>1. Information we collect</h2>
      <ul>
        <li><strong>Account data</strong>: your name, email address and hashed password.</li>
        <li><strong>Payment data</strong>: UPI transaction reference, Razorpay order/payment IDs, and the paid amount.
          <strong> Your full card, UPI PIN or bank credentials are never seen or stored by us</strong> — they are handled
          exclusively by Razorpay.</li>
        <li><strong>Clinical case data</strong>: patient labels (which you are asked to keep as initials / codes),
          clinical flags you tick in the workflow, generated protocol content, outcome and optional notes.</li>
        <li><strong>Technical data</strong>: session tokens, IP address, browser user-agent, and audit timestamps.</li>
      </ul>

      <h2>2. What we do NOT ask you to store</h2>
      <p>
        The Service is designed to work with <strong>de-identified case codes</strong> (e.g. initials, hospital ID) and
        does not require you to enter patient names, contact details, or Aadhaar / identifier numbers. Please do not
        upload directly identifying patient information into the Service.
      </p>

      <h2>3. How we use it</h2>
      <ul>
        <li>To operate the Service — authenticate you, save your cases, generate PDFs and cohort insights.</li>
        <li>To process your one-time lifetime access payment through Razorpay.</li>
        <li>To send transactional email (activation confirmation, monthly digest to the Owner) via Resend when configured.</li>
        <li>To improve the Service — aggregate factor frequency and success-rate analytics are computed within your
          own workspace only, and are never shared across clinicians without explicit prior consent.</li>
      </ul>

      <h2>4. Data storage & security</h2>
      <p>
        Data is stored in MongoDB under strict access controls. Passwords are hashed with bcrypt; session tokens are
        stored as httpOnly, secure cookies (with an authenticated-header fallback for browsers that block third-party
        cookies). Transport to and from the Service is over HTTPS.
      </p>

      <h2>5. Sharing</h2>
      <p>
        We share information only with the sub-processors necessary to operate the Service:
      </p>
      <ul>
        <li><strong>Razorpay</strong> — payment processing</li>
        <li><strong>Resend</strong> — transactional email delivery (when configured)</li>
        <li><strong>MongoDB Atlas</strong> — encrypted-at-rest database hosting</li>
        <li>Hosting infrastructure (Emergent, AWS, Cloudflare)</li>
      </ul>
      <p>
        We do not sell, rent, or trade personal information. We may disclose information if compelled by valid
        legal process (court order, regulator).
      </p>

      <h2>6. Your rights</h2>
      <p>
        You may at any time:
      </p>
      <ul>
        <li>Access and export your saved cases (available in the Service; a CSV is downloadable by the Owner too).</li>
        <li>Delete individual cases yourself, or request full account deletion by emailing us.</li>
        <li>Correct your account name/email through the Owner.</li>
      </ul>

      <h2>7. Retention</h2>
      <p>
        Case and account data are retained for as long as your account remains active. On account deletion, data is
        anonymised within 30 days and any residual backups are purged within 90 days.
      </p>

      <h2>8. Children</h2>
      <p>
        The Service is not directed at children under 18 and no such data is knowingly collected.
      </p>

      <h2>9. Contact & grievances</h2>
      <p>
        Data-protection queries and access / erasure requests can be sent to
        <strong> <a href="mailto:drmonashroff@gmail.com">drmonashroff@gmail.com</a></strong>. As required by the
        Information Technology (Reasonable Security Practices) Rules, 2011, our Grievance Officer is
        <strong> Dr. Mona Shroff</strong>, reachable at the same email address; we aim to acknowledge grievances
        within 48 hours and resolve them within 30 days.
      </p>

      <h2>10. Changes</h2>
      <p>
        Material changes to this policy will be flagged on the login page and via email at least 30 days before they
        take effect.
      </p>
    </LegalShell>
  );
}
